import {React, useEffect, useState} from 'react';
import img_puntos from '../assets/images/img_puntos.svg'
import img_footer_mobile from '../assets/images/img_footer_mobile.png';
const Footer = ({ footerFlag }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  return (
    (footerFlag) ?
    ((width > 800)?
      <div className='w-full h-fit bg-gray-100'>
        <div className='flex flex-col'>
          <a href="/">
            <img loading="lazy" className="object-cover w-full" src={img_puntos} alt=""></img>
          </a>

        </div>
      </div>
      :
      <div className='w-full h-fit bg-gray-100'>
        <div className='flex flex-col'>
          <a href="/">
            <img loading="lazy" className="object-cover w-full py-10 px-10" src={img_footer_mobile} alt=""></img>
          </a>

        </div>
      </div>)
      :
      null
  );
}

export default Footer;